import { ENV } from '@wolffun/env-var';
import { getAppConfig } from '@wolffun/app-config';
import { SYSTEM_DECIMALS } from '@wolffun/system-currency';
export { THETA_CHAIN_PROVIDER_URL, THETA_CHAIN_ID, THETAN_COIN_CONTRACT_ADDRESS, BUSD_CONTRACT_ADDRESS, WBNB_CONTRACT_ADDRESS, THETAN_GEM_CONTRACT_ADDRESS, THETA_MARKETPLACE_WALLET_ADDRESS, THETAN_BOX_PAYMENT_ADDRESS, CONVERT_THC_PAYMENT_ADDRESS, THETAN_COIN_DEPOSIT_ADDRESS, THETAN_GEM_DEPOSIT_ADDRESS, NFT_CONTRACT_ADDRESS, HERO_RENTAL_ADDRESS, STAKING_ADDRESS, CLAIM_TOKEN_ADDRESS, PRIVATE_SALE_CONTRACT_ADDRESS, FUSION_HERO_CONTRACT_ADDRESS, MINT_HERO_ADDRESS, MINT_COSMETIC_ADDRESS, DEPOSIT_TOKEN_CONTRACT_ADDRESS, THETA_CHAIN_ID_NUMBER, POLYGON_CHAIN_ID_NUMBER } from '@wolffun/contract-address';
const {
  endpoints
} = getAppConfig();
export const SYSTEM_CURRENCY_DECIMALS = SYSTEM_DECIMALS;
export const LS_ACCESS_TOKEN_KEY = 'theta/accessToken';
export const LS_REFRESH_TOKEN_KEY = 'theta/refreshToken';
export const THETA_MARKETPLACE_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://data.thetanarena.com/thetan/v1',
    uat: 'https://data.uat.thetanarena.com/theta/v1',
    staging: 'https://data.staging.thetanarena.com/theta/v1',
    test: 'https://data.staging.thetanarena.com/theta/v1'
  };
  return endpoints.thetanMarket || apis[ENV];
})();
export const THETA_DATA_API_ENDPOINT = THETA_MARKETPLACE_API_ENDPOINT;
export const THETA_LEADERBOARD_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://leaderboard.thetanarena.com/v1',
    uat: 'https://leaderboard.uat.thetanarena.com/v1',
    staging: 'https://leaderboard.staging.thetanarena.com/v1',
    test: 'https://leaderboard.staging.thetanarena.com/v1'
  };
  return endpoints.thetanLeaderboard || apis[ENV];
})();
export const THETA_REPORT_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://report.thetanarena.com/api/v1',
    uat: 'https://report.uat.thetanarena.com/api/v1',
    staging: 'https://report.staging.thetanarena.com/api/v1',
    test: 'https://report.staging.thetanarena.com/api/v1'
  };
  return endpoints.thetanReport || apis[ENV];
})();
export const THETA_AUTH_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://thetan-auth.thetanarena.com/api/v1',
    uat: 'https://thetan-auth.uat.thetanarena.com/api/v1',
    staging: 'https://thetan-auth.staging.thetanarena.com/api/v1',
    test: 'https://thetan-auth.staging.thetanarena.com/api/v1'
  };
  return endpoints.thetanAuth || apis[ENV];
})();
export const THETA_RESOURCE_ENDPOINT = (() => {
  const apis = {
    production: 'https://assets.thetanarena.com',
    uat: 'https://storage.googleapis.com/uat-thetanarena-asset',
    staging: 'https://storage.googleapis.com/thetan-staging-asset',
    test: 'https://storage.googleapis.com/thetan-staging-asset'
  };
  return endpoints.thetanResource || apis[ENV];
})();
export const THETAN_SUPPORT_API_ENDPOINT = (() => {
  const apis = {
    production: 'https://thetan-support.thetanarena.com/api',
    uat: 'https://thetan-support.uat.thetanarena.com/api',
    staging: 'https://thetan-support.staging.thetanarena.com/api',
    test: 'https://thetan-support.staging.thetanarena.com/api'
  };
  return endpoints.thetanSupport || apis[ENV];
})();
export const THETA_RESOURCE_WEBGL_ENDPOINT = (() => {
  const apis = {
    production: `${THETA_RESOURCE_ENDPOINT}/webgl`,
    uat: `${THETA_RESOURCE_ENDPOINT}/webgl`,
    staging: `${THETA_RESOURCE_ENDPOINT}/webgl`,
    test: `${THETA_RESOURCE_ENDPOINT}/webgl`
  };
  return endpoints.thetanResourceWEBGL || apis[ENV];
})();
export const CHAIN_NAME = (() => {
  const name = {
    production: 'Binance Smart Chain',
    uat: 'BSC Test Chain',
    staging: 'BSC Test Chain',
    test: 'BSC Test Chain'
  };
  return name[ENV];
})();
export const TRANSAK_ENDPOINT = (() => {
  const apis = {
    production: 'https://global.transak.com',
    uat: 'https://global-stg.transak.com',
    staging: 'https://global-stg.transak.com',
    test: 'https://global-stg.transak.com'
  };
  return apis[ENV];
})();
export const ALCHEMYPAY_CONFIG = (() => {
  const apis = {
    production: {
      endpoint: 'https://ramp.alchemypay.org',
      appId: '1kRo484uM241ohtM',
      secret: 'LZJDCdAycnNMf96J'
    },
    uat: {
      endpoint: 'https://ramp.alchemypay.org',
      appId: '1kRo484uM241ohtM',
      secret: 'LZJDCdAycnNMf96J'
    },
    staging: {
      endpoint: 'https://ramp.alchemypay.org',
      appId: '1kRo484uM241ohtM',
      secret: 'LZJDCdAycnNMf96J'
    },
    test: {
      endpoint: 'https://ramp.alchemypay.org',
      appId: '1kRo484uM241ohtM',
      secret: 'LZJDCdAycnNMf96J'
    }
  };
  return apis[ENV];
})();
export const TRANSAK_API_KEY = (() => {
  const apis = {
    production: '3d14b386-0397-4265-9bd3-59f23ad9316b',
    uat: 'dec06e4a-e182-41fd-891c-93aa493c200c',
    staging: 'dec06e4a-e182-41fd-891c-93aa493c200c',
    test: 'dec06e4a-e182-41fd-891c-93aa493c200c'
  };
  return apis[ENV];
})();
export const CONTACT_SUPPORT_URL = 'https://wolffun.helpshift.com/hc/en/';
export const TERMS_OF_USE_URL = 'https://doc.thetanarena.com/faqs/terms-of-use';
export const WALLET_PROVIDER_KEY = 'wallet_provider_key';
export const GIFT_CODE_KEY = 'thetan/gift_code_key';
export const GIFT_CODE_EXPIRATION_KEY = 'thetan/gift_code_expiration_key';
export const MARKET_DISABLE_CLAIM_BOX_REMOTE_KEY = 'market_disable_claim_box';
export const COINBASE_EVENT_KEY = 'marketplace_coinbase';
export const REFRESH_TOKEN_URL = `/refresh-token`;
export const MKP_PREFIX = 'thetanmkp';
export const ADS_POPUP_KEY = 'ads_popup';
export const ONBOARDING_KEY = 'thetan/onboarding';
export const DAILY_CHECKIN_KEY = 'thetan/daily_checkin';